var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { bookFromDoc } from './BookRepository';
const deletedBookFromDoc = (doc) => {
    const data = doc.data();
    return {
        id: doc.id,
        isbn: data.isbn,
        title: data.title,
        deletedBy: data.deletedBy,
        updatedAt: data.updatedAt.toDate(),
        createdAt: data.createdAt.toDate(),
    };
};
export class DeletedBookRepository {
    constructor(db, bookRepository) {
        this.db = db;
        this.bookRepository = bookRepository;
        this.collection = this.db.collection('deletedBooks');
        this.findAll = async () => {
            return this.collection.get().then(snapshot => snapshot.docs.map(deletedBookFromDoc));
        };
        this.deleteById = async (bookId, deletedBy) => {
            return this.db.runTransaction(async (tx) => {
                const bookRef = this.bookRepository.mkBookRefById(bookId);
                const target = await tx.get(bookRef).then(bookFromDoc);
                const { id, createdAt: _, updatedAt: _1 } = target, body = __rest(target, ["id", "createdAt", "updatedAt"]);
                const deletedBookRef = this.mkDeletedBookRefById(bookId);
                tx.delete(bookRef);
                const now = new Date();
                const deletedBookData = Object.assign(Object.assign({}, body), { deletedBy, createdAt: now, updatedAt: now });
                tx.set(deletedBookRef, deletedBookData);
                return target;
            });
        };
        this.bulkDelete = async (books) => {
            await this.db.runTransaction(async (tx) => {
                books.forEach(book => {
                    const { id } = book, body = __rest(book, ["id"]);
                    const bookRef = this.bookRepository.mkBookRefById(id);
                    const deletedBookRef = this.mkDeletedBookRefById(id);
                    tx.delete(bookRef);
                    const now = new Date();
                    const deletedBookData = Object.assign(Object.assign({}, body), { createdAt: now, updatedAt: now });
                    tx.set(deletedBookRef, deletedBookData);
                });
            });
        };
        this.mkDeletedBookRefById = (bookId) => this.collection.doc(bookId);
    }
}
//# sourceMappingURL=DeletedBookRepository.js.map